import getSolicitudesPurchaseHistoryClient from './getSolicitudesPurchaseHistoryClient'

export const getSolicitudesPurchaseHistoryClientPromise = getSolicitudesPurchaseHistoryClient
